module.exports = __webpack_public_path__ + "img/11128_PISTA.13ae50db.webp";